import { ApiError } from './ApiError';
import type { HttpClient } from './HttpClient';
import type { IAiAskRequest } from './IAiAskRequest';
import type { IAiAskResult } from './IAiAskResult';

/** Коди відповіді сервера, у якого ще немає ШІ-асистента: маршрут не знайдено, метод не дозволено, не реалізовано. */
const MISSING = new Set([404, 405, 501]);

/**
 * ШІ-асистент (POST /api/v1/ai/ask, gap AI-07): лише читання — сервер складає підказку з контексту й видимих користувачу полів і повертає
 * відповідь Markdown `{ reply }`. Сервер без цього API — { available: false }, щоб панель чесно сказала, що ШІ-сервер не під'єднано.
 */
export class AiDao {
  constructor(private readonly http: HttpClient) {}

  async ask(body: IAiAskRequest): Promise<IAiAskResult> {
    try {
      const res = await this.http.post<{ reply?: string | null; text?: string | null } | string>('/ai/ask', body);
      const reply = typeof res === 'string' ? res : res?.reply ?? res?.text ?? '';
      return { available: true, reply: reply.trim() };
    } catch (e) {
      if (e instanceof ApiError && MISSING.has(e.status)) return { available: false, reply: '' };
      throw e;
    }
  }
}
